module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_8017.3432f32f.png";